import { useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { categoryIdToSlug } from "../lib/categories";

const TEMAS = [
  { label: "Ansiedad",    id: "ANSIEDAD",              hoverColor: "#C49A8A" },
  { label: "Depresión",   id: "DEPRESIÓN",             hoverColor: "#8AA4C4" },
  { label: "Autoestima",  id: "AUTOESTIMA",            hoverColor: "#C4B48A" },
  { label: "Estrés",      id: "ESTRÉS",                hoverColor: "#A48AC4" },
  { label: "Duelo",       id: "DUELO",                 hoverColor: "#8AC4B4" },
  { label: "Relaciones",  id: "RELACIONES",            hoverColor: "#C48A9A" },
  { label: "Trauma",      id: "TRAUMA",                hoverColor: "#C4A08A" },
  { label: "Mindfulness", id: "MINDFULNESS",           hoverColor: "#8AC48A" },
  { label: "Límites",     id: "LÍMITES",               hoverColor: "#C4C48A" },
  { label: "Crecimiento", id: "CRECIMIENTO PERSONAL",  hoverColor: "#8AB4C4" },
];

function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function Temas() {
  const [hovered, setHovered] = useState<string | null>(null);

  return (
    <div id="temas" style={{ position: "relative", zIndex: 1, paddingTop: 100, textAlign: "center" }}>
      <div className="container">
        <Reveal>
          <h2 style={{
            fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(2rem, 6vw, 52px)",
            color: "#FFFFFF", margin: "0 0 12px",
          }}>
            ¿Qué te pesa hoy?
          </h2>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 16, margin: "0 0 48px" }}>
            Elige el tema que necesitas trabajar y recibe una guía gratuita
          </p>
        </Reveal>

        <div className="temas-chips">
          {TEMAS.map((t, i) => {
            const isHovered = hovered === t.id;
            return (
              <Reveal key={t.id} style={{ transitionDelay: `${i * 50}ms` }}>
                <Link
                  to={`/guia/${categoryIdToSlug(t.id)}`}
                  className="tema-chip-link"
                  onMouseEnter={() => setHovered(t.id)}
                  onMouseLeave={() => setHovered(null)}
                  style={{
                    background: isHovered ? t.hoverColor : "rgba(255,255,255,0.06)",
                    border: `1px solid ${isHovered ? t.hoverColor : "rgba(255,255,255,0.15)"}`,
                    color: isHovered ? "#fff" : "rgba(255,255,255,0.85)",
                    transform: isHovered ? "translateY(-3px) scale(1.04)" : "none",
                    boxShadow: isHovered ? `0 10px 30px ${hexToRgba(t.hoverColor, 0.35)}` : "none",
                  }}
                >
                  {t.label}
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
}
